import {
  generateCaughtError,
  nodeListToElements,
  toHTMLElement,
  nodeListToArray,
  isHTMLElement,
  first
} from './ts-utils';

const getFirstChild = (nodes: HTMLElement[]): HTMLElement | null => {
  const firstChild = first(
    childNode => childNode.nodeType !== Node.TEXT_NODE,
    nodes
  );

  return firstChild;
};

const getContentToAppend = (templateContent: HTMLElement[]) => {
  const firstChild = getFirstChild(templateContent);

  if (!firstChild) {
    generateCaughtError('no first child');
    return null;
  }

  if (firstChild.nodeName.toLowerCase() === 'script') {
    const scriptElm = document.createElement('script');
    const src = firstChild.getAttribute('src');

    if (!src) {
      generateCaughtError('source empty');
      return;
    }
    scriptElm.setAttribute('src', src);
    return scriptElm;
  }

  if (firstChild.nodeName.toLowerCase() === 'link') {
    return firstChild;
  }
  return firstChild;
};

const addCallback = (
  content: DocumentFragment | HTMLElement,
  cb: () => void = () => null
) => {
  if (isHTMLElement(content)) {
    if (content.tagName && content.tagName.toLowerCase() === 'script') {
      content.addEventListener('load', cb);
    }
    else if (content.tagName && content.tagName.toLowerCase() === 'link') {
      content.addEventListener('load', cb);
    }
  }
  else {
    cb();
  }
};

const append = (noscriptElm: HTMLElement, cb: () => void = () => null) => {
  const content = noscriptElm.textContent || noscriptElm.innerHTML;
  const noscriptParent = noscriptElm.parentNode;

  // using div because of IE
  const template = document.createElement('div');

  template.innerHTML = content;

  const contentToAppend = getContentToAppend(
    nodeListToArray(template.childNodes).filter(isHTMLElement).map(toHTMLElement)
  );

  if (!contentToAppend) {
    return;
  }

  addCallback(contentToAppend, cb);

  if (!noscriptParent) {
    generateCaughtError('problem getting noscript parent');
    return;
  }

  noscriptParent.insertBefore(contentToAppend, noscriptElm.nextSibling);
};

const mediaMatches = (noscriptElm: HTMLElement): boolean => {
  // console.log(noscriptElm);
  const dataMediaMatches = noscriptElm.getAttribute('data-media-matches');

  return dataMediaMatches ? window.matchMedia(dataMediaMatches).matches : true;
};

const loadElement = (noscriptElm: HTMLElement, cb: () => void = () => null) => {
  if (mediaMatches(noscriptElm)) {
    append(noscriptElm, cb);
  }
  else {
    const onResize = () => {
      if (mediaMatches(noscriptElm)) {
        append(noscriptElm);
        window.removeEventListener('resize', onResize);
      }
    };

    window.addEventListener('resize', onResize);
    cb();
  }
};

const loadStack = (deferredElements: HTMLElement[]) => {
  requestAnimationFrame(() => {
    loadElement(
      deferredElements[0],
      deferredElements.length > 1 ?
        () => {
          loadStack(deferredElements.slice(1));
        }
        : undefined
    );
  });
};

window.addEventListener('load', () => {
  const deferredElements = nodeListToElements(
    document.querySelectorAll('[data-deferred]')
  ).map(toHTMLElement);

  loadStack(deferredElements);
});



// WEBPACK FOOTER //
// ../work/src/js/deferred-loading.ts